var Matter = require('matter-js');
var isMobile = require('./isMobile.js').isMobile;

var BackgroundPhysics = function() {}

BackgroundPhysics.prototype.init = function(navigate) {
  // don't run on build.
  if (typeof(window) === 'undefined') return;

  window.addEventListener('load', function() {
    var mobile = isMobile();

    if (mobile) {
      console.log('Not running physics menu on mobile.');
      return;
    }

    setTimeout(function() {

      console.log('in BackgroundPhysics window.load timeout')

      var canvas = document.getElementById('backgroundcanvas');
      if (!canvas) {
        console.error('canvas not found')
        return;
      }

      var engine = Matter.Engine.create();

      var width = 100;
      var height = 100;

      var blankcolors = [
        '#111',
      ]

      var menuitems = [
        { color: '#ff3f3f', text: 'NEWS', link: '/', center: 0 },
        { color: '#f7f700', text: 'YELLOLOGY', link: '/yellology/', center: 0 },
        { color: '#f700b9', text: 'DISCOGRAPHY', link: '/discography/', center: 0 },
        { color: '#00ee00', text: 'VIDEOLOGY', link: '/videology/', center: 0 },
        { color: '#00fafa', text: 'YELLO BOOK', link: '/yellobook/', center: 0 },
        { color: '#3f3ffa', text: 'CONTACT', link: '/contact/', center: 0 },
        { color: '#f7f7f7', text: 'YELLOFIER APP', link: 'https://vimeo.com/445503077', center: 0 },
        { color: '#101010', text: 'ALBUM PLAYER', link: 'https://www.youtube.com/watch?v=kOyg4-oMLgc', center: 2 },
        { color: '#ffff80', text: 'YELLO SHOP', link: 'https://shop.point.yello.com/', center: 0 },
      ];

      function spawnDummyBox() {
        var x = Math.random() * 1000;
        var y = -(500 + 400.0) * Math.random();
        var s = 50 + Math.random() * 30;
        var boxB = Matter.Bodies.rectangle(x, y, s, s, { chamfer: { radius: 10 }, restitution: 0.2 });
        Matter.Body.rotate(boxB, Math.random() * Math.PI * 3.0);
        Matter.World.add(engine.world, boxB);
      }

      function spawnMenuItem(menuitem) {
        var x = Math.random() * 1000;
        var y = -(600 + 400.0) * Math.random();
        var boxB = Matter.Bodies.rectangle(x, y, 140, 140, { chamfer: { radius: 20 }, restitution: 0.2 });
        Matter.Body.rotate(boxB, Math.random() * Math.PI * 3.0);
        Matter.World.add(engine.world, boxB);
        boxB.menuitem = menuitem;
      }

      for(var j=0; j<35; j++) {
        setTimeout(function(j) { spawnDummyBox(); }.bind(this, j), 50 + 90 * j);
      }

      for(var j=0; j<menuitems.length; j++) {
        setTimeout(function(j) { spawnMenuItem(menuitems[j]); }.bind(this, j), 100 + 300 * j);
      }

      var ground = Matter.Bodies.rectangle(400, 610, 3000, 20, { isStatic: true, restitution: 0.2 });
      var left = Matter.Bodies.rectangle(100, 500, 20, 3000, { isStatic: true, restitution: 0.2 });
      var right = Matter.Bodies.rectangle(800, 500, 20, 3000, { isStatic: true, restitution: 0.2 });
      Matter.World.add(engine.world, [left, right, ground]);

      function updateCanvasSize() {
        width = window.innerWidth;
        height = window.innerHeight;
        if (width <= 1000)
          height = Math.round(width * 0.66);
        if (height < 300)
          height = 300;
        // console.log('update canvas size.');
        if (canvas) {
          canvas.style.width = width + 'px';
          canvas.style.height = height + 'px';
          // width *= 2;
          // height *= 2;
          canvas.width = width;
          canvas.height = height;
        }

        Matter.Body.setPosition(ground, { x: width / 2, y: height + 10 })
        Matter.Body.setPosition(left, { x: -10, y: height / 2 })
        Matter.Body.setPosition(right, { x: width + 10, y: height / 2 })
      }

      var mouseConstraint = Matter.MouseConstraint.create(engine, {
        element: canvas
      });

      var clickdetect = {
        x: 0,
        y: 0,
        time: 0,
        menuitem: null,
      }

      var selection = {
        state: '',
        frame: 0,
        body: null,
        menuitem: null,
      }

      Matter.Events.on(mouseConstraint, 'mousemove', function(event) {
        var mousePosition = event.mouse.position;


        clickdetect.time = (new Date()).getTime();
        clickdetect.menuitem = null;
        clickdetect.body = null;

        var bodies = Matter.Composite.allBodies(engine.world);
        var collisions = Matter.Query.point(bodies, event.mouse.position);
        // console.log('collisions', collisions);

        if (collisions.length > 0) { // } && typeof(collisions[0].menuitem) !== 'undefined') {
          clickdetect.menuitem = collisions[0].menuitem;
          clickdetect.body = collisions[0];

          if (clickdetect.menuitem) {
            backgroundmenuhint.style.left = collisions[0].position.x + 'px';
            backgroundmenuhint.style.top = collisions[0].position.y + 'px';
            backgroundmenuhint.className = 'visible';
            backgroundmenuhint.innerHTML = '<span>' + collisions[0].menuitem.text + '</span>';
          } else {
            backgroundmenuhint.className = '';
          }
        } else {
          backgroundmenuhint.className = '';
        }
      });

      var backgroundmenuhint = document.getElementById('backgroundmenuhint');

      // an example of using mouse events on a mouse
      Matter.Events.on(mouseConstraint, 'mousedown', function(event) {
        var mousePosition = event.mouse.position;
        console.log('mousedown at ' + mousePosition.x + ' ' + mousePosition.y);
        clickdetect.x = mousePosition.x;
        clickdetect.y = mousePosition.y;
      });

      // an example of using mouse events on a mouse
      Matter.Events.on(mouseConstraint, 'mouseup', function(event) {
        var mousePosition = event.mouse.position;
        backgroundmenuhint.className = '';
        var dx = Math.abs(mousePosition.x - clickdetect.x);
        var dy = Math.abs(mousePosition.y - clickdetect.y);
        var dt = (new Date()).getTime() - clickdetect.t;
        // console.log('mouseup at ' + mousePosition.x + ' ' + mousePosition.y, dx,dy,dt);
        if (dt > 300 || dx > 10 || dy > 10) return;
        if (clickdetect.body) {
          // console.log('clicked on a body', clickdetect.body);
          if (clickdetect.menuitem) {
            console.log('clicked on a menuitem', clickdetect.menuitem);
          }
          if (selection.state == '') {
            // console.log('start shrinking...');
            // no item selected, we're selecting one.
            selection.state = 'selected';
            selection.body = clickdetect.body;
            selection.menuitem = clickdetect.menuitem;
            selection.frame = 0;
          }
        }
      });

      if (window) window.addEventListener('resize', updateCanvasSize.bind(this));

      Matter.Events.on(engine, 'beforeUpdate', function(event) {

        var bodies = Matter.Composite.allBodies(engine.world);

        if (event.timestamp % 500 < 50) {
          for (var i = 0; i < bodies.length; i++) {
            var body = bodies[i];
            if (!body.isStatic) {
              // console.log('check body', body);
              if ((body.position.y >= (height + 200)) ||
                  (body.position.x > (width + 200)) ||
                  (body.position.x < -200)) {
                // console.log('reposition block', body);
                Matter.Body.setPosition(body, { x: width * Math.random(), y: -300 - 200 * Math.random() });
              }
            }
          }
        }

        if (selection.state == 'selected') {
          // shrink that selected body.

          if (selection.frame >= 0 && selection.frame < 10) {

            var s = 1.0 - 0.2 * selection.frame / 10.0;
            var o = 1.0 - 1.0 * selection.frame / 10.0;
            if (o < 0.0) o = 0.0;
            Matter.Body.scale(selection.body, s, s);
            // selection.body.render.fillStyle = '#f0f';
            selection.body.render.opacity = o;

          } else if (selection.frame == 11) {

            Matter.World.remove(engine.world, selection.body);
            selection.body = null;

            // recreate body on top
            if (selection.menuitem) {
              spawnMenuItem(selection.menuitem);
            } else {
              spawnDummyBox();
            }

            // reset selection state
          } else if (selection.frame == 12) {

            if (selection.menuitem) {
              if (selection.menuitem.link.indexOf('http') !== -1) {
                window.open(selection.menuitem.link);
              } else {
                navigate(selection.menuitem.link);
              }
            }
            selection.menuitem = null;

            selection.state = '';
            selection.frame = 0;
          }

          selection.frame ++;

        }

        if (clickdetect.body && clickdetect.menuitem) {
          backgroundmenuhint.style.left = clickdetect.body.position.x + 'px';
          backgroundmenuhint.style.top = clickdetect.body.position.y + 'px';
        }
      });

      // add all of the bodies to the world
      // Matter.World.add(engine.world, [boxA, boxB, ground]);

      Matter.World.add(engine.world, mouseConstraint);

      // pass mouse to renderer to enable showMousePosition
      // render.mouse s= mouseConstraint.mouse;

      updateCanvasSize();

      engine.world.gravity.y = 2.0;

      // run the engine
      Matter.Engine.run(engine);

      var context = canvas.getContext('2d');

      var centerimages = [];

      centerimages[0] = new Image();
      centerimages[0].src = '/img/block0.png';

      centerimages[1] = new Image();
      centerimages[1].src = '/img/block1.png';

      centerimages[2] = new Image();
      centerimages[2].src = '/img/block2.png';

      (function render() {
        var bodies = Matter.Composite.allBodies(engine.world);

        window.requestAnimationFrame(render);

        // context.fillStyle = '#fff';
        context.clearRect(0, 0, canvas.width, canvas.height);

        for (var i = 0; i < bodies.length; i += 1) {
          var body = bodies[i];

          if (bodies[i].isStatic) continue;

          context.beginPath();

          var vertices = body.vertices;

          context.moveTo(vertices[0].x, vertices[0].y);

          for (var j = 1; j < vertices.length; j += 1) {
            context.lineTo(vertices[j].x, vertices[j].y);
          }

          context.lineTo(vertices[0].x, vertices[0].y);

          // if (body.menuitem) {
          //   context.lineWidth = 2;
          //   context.strokeStyle = 'rgba(0,0,0,1)';
          //   context.stroke();
          // }

          if (body.menuitem)
            context.fillStyle = body.menuitem.color;
          else
            context.fillStyle =  blankcolors[i % blankcolors.length];
          context.fill();

          context.save();

          context.translate(body.position.x, body.position.y);
          context.rotate(body.angle);
          if (body.menuitem && centerimages[body.menuitem.center]) {
            context.drawImage(centerimages[body.menuitem.center], -50, -50, 100, 100);
          }

          context.restore();

        }
      })();

      // run the renderer
      // Matter.Render.run(render);

    }, 100);
  });
}

// module.exports = BackgroundPhysics;
export default BackgroundPhysics;
